const config = {
  basename: '',
  defaultPath: '/dashboard',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12
};

export const ADVERTISERS_ALLOWED_CURRENT_DATE = [
  '9ebde7f57d7f480eb0464cafd229b669',
  '8c9264310d8d4951806ad0b8b05936cc',
  '236c4a248d0040afbaf6c73ad2d4d7fd',
  'be609d8e5e464e719ef2dac474c3f7f3',
  '9f170b3d810649cab14222d0c973f5b1',
  '2a2fd5f00764448b9d2676f3a3640c35',
  'ec7fd8f16ecc417884646e1e08a9c826',
  'a4e2a829f59343c89768ab962ebb66ed',
  'c78b2b70ab6a41cf9085243922627144',
  '77a8b57ffc824c54b942049fda3229ae',
  'fad268e15a7d46b0a06bf23368136e5b'
];

export default config;
